<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import { Props } from "@/components/ShapeType.vue";
import ValidationMessage from '@/components/UI/ValidationMessage.vue';

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'droplet', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const message = computed(() => store.getters.getInstructionsForDimension);

const height = computed({
	get: () => dimensions.value.height,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height",
			value: value,
		});
	},
});

const width = computed({
	get: () => dimensions.value.width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="droplet-width"
			:id="`${prefix}measurements-droplet-width`"
			:name="`${prefix}measurements[dimensions][width]`"
			unit="cm"
			:label="dimensionLabel('width')"
			:instructions="isCutout ? '' : dimensionMaxLabel('width')"
			:invalid="!isDimensionValid(`${prefix}droplet-width`)"
			:onBlur="() => addSizeToDataLayer('width', +width, 'droplet')"
			v-model="width"
		/>
		<dimension-input
			inputRef="droplet-height"
			:id="`${prefix}measurements-droplet-height`"
			:name="`${prefix}measurements[dimensions][height]`"
			unit="cm"
			:label="dimensionLabel('height')"
			:instructions="isCutout ? '' : dimensionMaxLabel('height')"
			:invalid="!isDimensionValid(`${prefix}droplet-height`)"
			:onBlur="() => addSizeToDataLayer('height', +height, 'droplet')"
			v-model="height"
		/>
		<div class="full" v-if="message('width', 'height', isCutout)">
			<validation-message type="notice">
				{{ message('width', 'height', isCutout) }}
			</validation-message>
		</div>
		<div class="full" v-if="message('height', 'width', isCutout)">
			<validation-message type="notice">
				{{ message('height', 'width', isCutout) }}
			</validation-message>
		</div>
	</shape-input-fields-wrapper>
</template>
<style scoped lang="scss">
.full {
	grid-column: 1 / -1;
}
</style>
